/* eslint-disable jsx-a11y/anchor-is-valid */
import { CarouselPage } from "./CarouselPage";
import backIcon from '../assets/img/back.svg';
import downloadIcon from '../assets/img/download.svg';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { buildTimeRange } from '../modules/utils';
import config from '../SysConfig.json';
import { useState, useEffect } from 'react';
import { annoHelper } from '../dal/annoHelper';
import dayjs from 'dayjs';

interface FilterParams {
  query: string;
  limit: number;
  page: number;
  tag: string;
  unit: string;
}


export const NewsView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const itemid = searchParams.get('itemid');

  const [item, setItem] = useState<any>(location.state?.item || null);
  const callback = location.state?.callback;

  useEffect(() => {
    if (!item && itemid) {
      annoHelper.getOpenAnnoById(itemid).then((data) => {
        if (data) {
          setItem(data);
        }
      });
    }
  }, [itemid]);

  const handlePageBack = (e: React.MouseEvent) => {
    e.preventDefault();

    if (callback) {
      // Navigate back and maintain the filter parameters
      const filterParams: FilterParams = callback;

      navigate(`/newsall?init=false&query=${filterParams.query}&limit=${filterParams.limit}&page=${filterParams.page}&tag=${filterParams.tag}&unit=${filterParams.unit}`);
      console.log('callback', callback);
    } else {
      navigate(-1 as unknown as string);
    }
  };

  if (!item) {
    return <></>;
  }

  return (
    <div>
      <div className="flex items-center staticBanner bg-[#fdfbc9] relative">
        <div className="staticBannerContent">
          <img
            src="/images/resourceBanner.png"
            alt="banner"
            className="staticBannerImg"
          />
          <div className="text-base sm:text-lg md:text-3xl absolute w-[40%] max-w-[400px] -translate-x-[45%] max-h-full">
            <h2 className=" font-black text-primaryDark leading-tight ">數位資源一站式</h2>
            <p className="text-secondaryDark mt-[0.5em] text-[0.65em] leading-normal">
              透過我們的平台，學生只需一個帳號即可使用天下雜誌群知識庫、均一教育平台等多種數位資源，享受無縫學習體驗，拓展知識，培養技能，為未來成長打下堅實基礎。
            </p>
          </div>
        </div>
      </div>
      <div className='content text-Headline px-4 mx-auto'>
        <div className='text-lg lg:text-3xl w-fit border-b-4 border-primary font-medium mt-6 mb-4 lg:my-12 p-1 lg:p-3 mx-auto'>最新消息</div>
        <div className='news border-[3px] border-primary custom-shadow p-4 lg:p-8'>
          <div>
            <div className='flex flex-wrap justify-between items-center gap-4 my-4 text-base lg:text-2xl'>
              <div className='flex flex-wrap items-center gap-4 lg:gap-10'>
                {
                  (item.is_top) ?
                    <div className='bt-yellow flex-shrink-0 py-1 px-4 text-base lg:text-xl'>{item.unit_name}</div>
                    :
                    <div className='bt-purple flex-shrink-0 py-1 px-4 text-base lg:text-xl'>{item.unit_name}</div>
                }
                <div className='bt-green flex-shrink-0 py-1 px-4 text-base lg:text-xl'>{item.anno_tag}</div>
                <div className=''>{item.title}</div>
              </div>
              <div className='whitespace-nowrap text-[#9b9b9b] text-sm lg:text-xl ml-auto'>{buildTimeRange((item.start_at) ? item.start_at : '', (item.end_at) ? item.end_at : '')}</div>
            </div>
            <hr className="my-6 lg:my-9" />
            <div className="flex flex-col gap-4 text-base lg:text-2xl mb-3" dangerouslySetInnerHTML={{ __html: item.content }}></div>
            <hr className="my-6 lg:my-9" />
            {(item.attachments) &&
              item.attachments.map((att: any) => {
                return (
                  <div className='flex items-start gap-2 mb-3'>
                    <img src={downloadIcon} alt="" />
                    <a href={"/uploads/" + config.uploadDirectiory + "/" + att.file_name} className='hover:opacity-80 hover:underline text-[#009FCF] text-base lg:text-lg' target="_blank" rel="noreferrer noopener">
                      {att.source_file_name}
                    </a>
                  </div>
                )
              })
            }
            <a
              href="#"
              onClick={handlePageBack}
              className='flex justify-end items-center gap-2 hover:opacity-75 !text-primary text-sm lg:text-2xl mt-10 !no-underline'>
              <img src={backIcon} alt="" className="w-4 lg:w-6" />返回
            </a>

          </div>
        </div>
      </div>

      <div className="p-7 lg:p-16"></div>
    </div >
  );
};
